var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "User,Profile.14",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 661",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2342",
    d: "M29.468 12.095a5.729 5.729 0 11-8.1 0 5.729 5.729 0 018.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2343",
    d: "M35.834 39.584a10.418 10.418 0 00-20.277-3.366 9.945 9.945 0 00-.556 3.366"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2344",
    d: "M0 0h50v50H0z",
    fill: "none"
  })));
}

export default SvgSingle;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Single.svg
// module id = 887
// module chunks = 101